import { render } from "./CompanyDetailsPage.vue?vue&type=template&id=0cb5e793&scoped=true"
import script from "./CompanyDetailsPage.vue?vue&type=script&lang=js"
export * from "./CompanyDetailsPage.vue?vue&type=script&lang=js"

import "./CompanyDetailsPage.vue?vue&type=style&index=0&id=0cb5e793&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb5e793"]])

export default __exports__